<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-lightborder table-striped table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Nit</th>
          <th>Cliente</th>
          <th>Fecha</th>
          <th>Caja</th>
          <th>Serie</th>
          <th>Monto</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in data.results"
          v-bind:key="current.id"
          @click="rowClick(current)"
        >
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda.nombre }}</td>
          <td>{{ current.cliente.nit }}</td>
          <td>{{ current.cliente.nombre }}</td>
          <td>{{ current.fecha }}</td>
          <td>
            <span v-if="current.pedido_e">{{ current.pedido_e.caja }}</span>
          </td>
          <td>{{ current.cargo_serie.serie }}</td>
          <td>{{ current.valor_total }}</td>
          <td class="text-center">
            <div
              data-title="Activo"
              data-toggle="tooltip"
              v-html="current.estado_str"
            ></div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  props: ["data"],
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cxc-cargos-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cxc-cargos-editar",
          params: { id: current.id },
        });
      }
    },
  },
};
</script>
